export const GET_STRIPE_INFO = 'GET_STRIPE_INFO'
